"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = CapApolloPlugin;
var client_1 = require("@apollo/client");
function CapApolloPlugin(_a) {
    var CapGraphqlProvider = _a.CapGraphqlProvider, signals = _a.signals;
    return {
        name: 'CapApolloPlugin',
        onBrowserHydrateRenderContext: function (context, next) {
            var _a, _b;
            var logger = context.logger, getAppData = context.getAppData, setAppData = context.setAppData;
            var _c = getAppData(), stores = _c.stores, dyffContext = _c.dyffContext, existingApollo = _c.apollo;
            var page = (stores && stores.page) || {};
            var config = (stores && stores.config) || {};
            var useRum = ((_a = dyffContext === null || dyffContext === void 0 ? void 0 : dyffContext.find(function (feature) { return feature.featureId === 'GRAPHQL_RUM'; })) === null || _a === void 0 ? void 0 : _a.result) === true;
            var publishPerformanceStats = ((_b = dyffContext === null || dyffContext === void 0 ? void 0 : dyffContext.find(function (feature) { return feature.featureId === 'GRAPHQL_PERFORMANCE_STATS'; })) === null || _b === void 0 ? void 0 : _b.result) === true;
            var publishErrorMessage = signals.publishErrorMessage, publishFrustrationMessage = signals.publishFrustrationMessage, publishActionMessage = signals.publishActionMessage;
            var publishError = function (string, error) {
                return publishErrorMessage(string, logger, error);
            };
            var publishFrustration = function (category, error) {
                return publishFrustrationMessage(category, logger, error);
            };
            var publishAction = function (action, context) {
                return publishActionMessage(action, context);
            };
            var links = CapGraphqlProvider.getLinks('EGA', page, config.appConfig, false, null, publishError, publishFrustration, publishAction, useRum, publishPerformanceStats);
            var cacheOptions = existingApollo.client.cache.config;
            var apolloClient = new client_1.ApolloClient({
                link: client_1.ApolloLink.from(links),
                cache: new client_1.InMemoryCache({
                    dataIdFromObject: cacheOptions.dataIdFromObject,
                    typePolicies: cacheOptions.typePolicies,
                    possibleTypes: cacheOptions.possibleTypes,
                    // @ts-ignore
                }).restore(window.__APOLLO_STATE__),
                resolvers: {},
                connectToDevTools: config.appConfig.deployedEnv !== 'production',
            });
            setAppData({
                apollo: {
                    client: apolloClient,
                },
            });
            return next(context);
        },
        onBrowserWrapRootElement: function (context, next) {
            return next(context);
        },
    };
}
//# sourceMappingURL=browser.js.map